import styled from 'styled-components'

const RedBulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    position: relative;
    padding-left: 1.25rem;
    @media (min-width: 768px) {
      padding-left: 2rem;
    }
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.6em;
      width: 0.5rem;
      height: 0.5rem;
      background-color: #F04248;
      border-radius: 3px;
    }
  }
`

export default RedBulletList
